import { BoneTag } from '@/generated';
import { boneTagApi } from '@/generated/clients';
import { useEffect, useState } from 'react';

export function useBoneTagMap() {
  const [boneTagList, setBoneTagList] = useState<Array<BoneTag>>([]);
  const [boneTagMap, setBoneTagMap] = useState<Map<string, BoneTag>>(new Map<string, BoneTag>());
  const [boneTagLoadError, setError] = useState<string | undefined>();

  const loadBoneTagMap = async () => {
    try {
      const boneTags = await boneTagApi.boneTagList();
      setBoneTagList(boneTags);
      const boneTagMap = new Map<string, BoneTag>();
      boneTags.forEach((bzt) => boneTagMap.set(bzt.id, bzt));
      setBoneTagMap(boneTagMap);
      setError(undefined);
    } catch (e) {
      if (e instanceof Error) setError(e.message);
    }
  };

  useEffect(() => {
    loadBoneTagMap();
  }, []);

  return { boneTagList, boneTagMap, boneTagLoadError, loadBoneTagMap } as const;
}
